import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Table,
    Container,
    Row,
    Col,
    FormGroup,
    Label,
    Input,
    Alert,
    Spinner,
} from "reactstrap";
import * as dynamicConfigService from "../../services/api/dynamic-config-template-service";
import UserContext from "../../UserContext";

const DynamicSchemaTemplatesList = () => {
    const history = useHistory();
    const context = useContext(UserContext);
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [name, setName] = useState("");
    const [templateKey, setTemplateKey] = useState("");
    const [alert, setAlert] = useState(null);

    const load = async () => {
        setLoading(true);
        const res = await dynamicConfigService.listDynamicConfigTemplates();
        if (res.status && res.data) setTemplates(res.data);
        else if (!res.status && res.error?.errorCode === 403) context.setIsAuthorized(context);
        setLoading(false);
    };

    useEffect(() => {
        load();
    }, []);

    const create = async (e) => {
        e.preventDefault();
        setSaving(true);
        setAlert(null);
        const res = await dynamicConfigService.createDynamicConfigTemplate({ name, templateKey });
        setSaving(false);
        if (res.status && res.data?.meta?._id) {
            setName("");
            setTemplateKey("");
            await load();
            history.push(`/template/dynamic-config-templates/build/${res.data.meta._id}`);
        } else {
            setAlert({
                type: "danger",
                msg: res.error?.message || res.data?.message || "Could not create template",
            });
        }
    };

    if (loading) {
        return (
            <Container className="mt-4">
                <Spinner />
            </Container>
        );
    }

    return (
        <Container fluid className="mt-4">
            <Row>
                <Col md="12">
                    <h3>Schema templates (base)</h3>
                    <p className="text-muted">
                        Reusable definitions. Publish versions, then fork into project instances.
                    </p>
                </Col>
            </Row>
            {alert && (
                <Alert color={alert.type} style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                    <span>{alert.msg}</span>
                    <button
                        type="button"
                        onClick={() => setAlert(null)}
                        style={{
                            background: "rgba(0,0,0,0.2)",
                            border: "none",
                            borderRadius: 4,
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "1rem",
                            lineHeight: 1,
                            padding: "2px 7px",
                            marginLeft: 12,
                            cursor: "pointer",
                            flexShrink: 0,
                        }}
                        aria-label="Close"
                    >
                        ✕
                    </button>
                </Alert>
            )}
            <Row>
                <Col md="5">
                    <Card>
                        <CardHeader>Create template</CardHeader>
                        <CardBody>
                            <form onSubmit={create}>
                                <FormGroup>
                                    <Label>Name</Label>
                                    <Input value={name} onChange={(e) => setName(e.target.value)} />
                                </FormGroup>
                                <FormGroup>
                                    <Label>Template key</Label>
                                    <Input
                                        value={templateKey}
                                        onChange={(e) => setTemplateKey(e.target.value)}
                                        placeholder="home-page-config"
                                    />
                                </FormGroup>
                                <Button color="primary" disabled={saving}>
                                    {saving ? "Creating…" : "Create"}
                                </Button>
                            </form>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="7">
                    <Card>
                        <CardHeader>Templates</CardHeader>
                        <CardBody>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Key</th>
                                        <th>Published ver.</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {templates.map((t) => (
                                        <tr key={t._id}>
                                            <td>{t.name}</td>
                                            <td>{t.templateKey}</td>
                                            <td>{t.currentVersion}</td>
                                            <td>
                                                <Button
                                                    size="sm"
                                                    color="info"
                                                    onClick={() =>
                                                        history.push(
                                                            `/template/dynamic-config-templates/build/${t._id}`
                                                        )
                                                    }
                                                >
                                                    Open builder
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            {templates.length === 0 && <p className="text-muted">No templates yet.</p>}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default DynamicSchemaTemplatesList;
